<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">Shops</h1>
        <div class="mb-6 flex justify-between items-center">
            <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
            </search-filter>
            <inertia-link class="btn-indigo" :href="route('shops.create')">
                <span>Create</span>
                <span class="hidden md:inline">Shop</span>
            </inertia-link>
        </div>
        <div class="bg-white rounded shadow overflow-x-auto">
            <table class="w-full whitespace-no-wrap">
                <tr class="text-left font-bold">
                    <th class="px-6 pt-6 pb-4">name</th>
                    <th class="px-6 pt-6 pb-4">city</th>
                </tr>
                <tr v-for="shop in shops.data" :key="shop.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('shops.edit', shop.id)">
                            {{ shop.name }}
                            <icon v-if="shop.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('shops.edit', shop.id)" tabindex="-1">
                            {{ shop.city.name }}
                        </inertia-link>
                    </td>
                    <td class="border-t w-px">
                        <inertia-link class="px-4 flex items-center" :href="route('shops.edit', shop.id)" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                        </inertia-link>
                    </td>
                </tr>
                <tr v-if="shops.data.length === 0">
                    <td class="border-t px-6 py-4" colspan="4">No shop found.</td>
                </tr>
            </table>
        </div>
      <pagination :links="shops.links" />
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'

export default {
    metaInfo: { title: 'Shops' },
    layout: Layout,
    components: {
        Icon,
        SearchFilter,
        Pagination,
    },
    props: {
        shops: Object,
        filters: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
            },
        }
    },
    watch: {
        form: {
            handler: throttle(function() {
                let query = pickBy(this.form)
                this.$inertia.replace(this.route('shops', Object.keys(query).length ? query : { remember: 'forget' }))
            }, 150),
            deep: true,
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
